import {LISTING_SECTION_IDS} from './listingSections.js'

export const LISTING_SECTIONS_WITH_AI_SEARCH_AI = [
  LISTING_SECTION_IDS.ALL_VEHICLES,
  LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES,
  LISTING_SECTION_IDS.KM0_VEHICLES,
  LISTING_SECTION_IDS.NEW_VEHICLES,
  LISTING_SECTION_IDS.RENTING_VEHICLES,
  LISTING_SECTION_IDS.SECOND_HAND_VEHICLES,
  LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES
]
